import type { Catalog } from "./en";

export const ko: Catalog = {
  "common.retry": "다시 시도",
  "common.reload": "새로고침",
  "common.save": "저장",
  "common.saving": "저장 중…",
  "common.saved": "저장했습니다",
  "common.saveFailed": "저장하지 못했습니다",
  "common.saveChanges": "변경 사항 저장",
  "common.delete": "삭제",
  "common.remove": "제거",
  "common.cancel": "취소",
  "common.edit": "편집",
  "common.openLink": "열기",
  "common.back": "← 뒤로",
  "common.loading": "불러오는 중",
  "common.loadingMore": "불러오는 중…",
  "common.sending": "보내는 중…",
  "common.error": "문제가 발생했습니다",
  "common.failed": "실패했습니다",
  "common.name": "이름",
  "common.email": "이메일",
  "common.title": "제목",
  "common.language": "언어",

  "time.now": "방금",
  "time.lessThanMinute": "1분 미만",
  "time.minutes": "{n}분",
  "time.hours": "{n}시간",
  "time.days": "{n}일",

  "nav.inbox": "받은편지함",
  "nav.faq": "도움말 센터",
  "nav.reports": "보고서",
  "nav.settings": "설정",
  "layout.workspace": "워크스페이스",
  "layout.newWorkspace": "+ 새 워크스페이스",
  "layout.signOut": "로그아웃",

  "app.unreachable.title": "서버에 연결할 수 없습니다",
  "app.unreachable.body": "연결 상태를 확인한 뒤 다시 시도해 주세요.",
  "app.noWorkspaces.title": "아직 워크스페이스가 없습니다",
  "app.noWorkspaces.body": "관리자에게 워크스페이스 초대를 요청하세요.",

  "error.pane": "이 대화를 표시할 수 없습니다.",
  "error.tryAgain": "다시 시도",
  "error.body": "이 화면에서 예기치 않은 오류가 발생했습니다.",
  "error.goInbox": "받은편지함으로 이동",

  "login.title": "지원팀 로그인",
  "login.sent": "{email}에 접근 권한이 있다면 로그인 링크가 발송되었습니다. 링크는 15분 후에 만료됩니다.",
  "login.intro": "일회용 로그인 링크를 이메일로 보내 드립니다.",
  "login.email": "업무용 이메일",
  "login.sendFailed": "링크를 보내지 못했습니다. 1분 후에 다시 시도해 주세요.",
  "login.submit": "링크 이메일로 받기",
  "verify.incomplete": "링크가 완전하지 않습니다.",
  "verify.failed": "로그인하지 못했습니다.",
  "verify.expired": "링크가 만료되었습니다",
  "verify.signingIn": "로그인하는 중…",
  "verify.newLink": "새 링크 요청",

  "newWs.superAdminOnly": "슈퍼 관리자만 워크스페이스를 만들 수 있습니다.",
  "newWs.created": "워크스페이스를 만들었습니다",
  "newWs.copySecret": "지금 ID 시크릿을 복사하세요. 한 번만 표시됩니다(나중에 다시 생성할 수 있습니다).",
  "newWs.secretLabel": "ID 시크릿(서버 전용)",
  "newWs.continue": "설정 계속하기",
  "newWs.createFailed": "워크스페이스를 만들지 못했습니다",
  "newWs.title": "새 워크스페이스",
  "newWs.intro": "앱 또는 제품마다 워크스페이스 하나. 각 워크스페이스에는 자체 도움말 센터, 받은편지함, 키가 있습니다.",
  "newWs.submit": "워크스페이스 만들기",

  "reports.period": "기간",
  "reports.lastDays": "최근 {count}일",
  "reports.loadFailed": "보고서를 불러오지 못했습니다.",
  "reports.conversations": "대화",
  "reports.resolved": "해결됨",
  "reports.medianReply": "첫 응답 시간(중앙값)",
  "reports.satisfaction": "만족도",
  "reports.ratingsCount": "평가 {count}개",
  "reports.ratingsCount.one": "평가 {count}개",
  "reports.ratingsCount.other": "평가 {count}개",
  "reports.ratings": "평가",
  "reports.barLabel": "{score}점 평가 {count}개",
  "reports.barLabel.one": "{score}점 평가 {count}개",
  "reports.barLabel.other": "{score}점 평가 {count}개",
  "reports.recentComments": "최근 의견",
  "reports.noComments": "아직 의견이 없습니다.",

  "status.open": "진행 중",
  "status.pending": "대기 중",
  "status.resolved": "해결됨",

  "inbox.title": "지원 받은편지함",
  "inbox.conversations": "대화",
  "inbox.liveStopped": "실시간 업데이트가 중지되었습니다.",
  "inbox.notifyPrompt": "새 메시지를 데스크톱 알림으로 받아 보세요.",
  "inbox.enableNotifications": "알림 켜기",
  "inbox.notNow": "나중에",
  "inbox.statusFilter": "상태",
  "inbox.assignee": "담당자",
  "inbox.all": "전체",
  "inbox.mine": "내 대화",
  "inbox.unassigned": "미배정",
  "inbox.loadFailed": "대화를 불러오지 못했습니다.",
  "inbox.empty.open": "진행 중인 대화가 없습니다 🎉",
  "inbox.empty.pending": "대기 중인 대화가 없습니다 🎉",
  "inbox.empty.resolved": "해결된 대화가 없습니다 🎉",
  "inbox.you": "나",
  "inbox.agent": "상담원",
  "inbox.attachment": "📎 첨부 파일",
  "inbox.unreadCount": "읽지 않음 {count}개",
  "inbox.loadMoreFailed": "대화를 더 불러오지 못했습니다",
  "inbox.loadMore": "더 불러오기",
  "inbox.select": "대화를 선택하세요",
  "inbox.visitor": "방문자 {id}",

  "contact.aria": "연락처",
  "contact.verified": "✓ 인증된 사용자",
  "contact.anonymous": "익명 방문자",
  "contact.userId": "사용자 ID",
  "contact.lastSeen": "마지막 접속",
  "contact.started": "시작 시각",
  "contact.rating": "평가",

  "event.resolved": "해결됨",
  "event.reopened": "다시 열림",
  "event.assigned": "배정됨",
  "event.csat_request": "평가 요청됨",
  "event.auto_reply": "자동 응답",

  "sys.resolved": "해결됨으로 표시했습니다",
  "sys.reopened": "다시 열었습니다",
  "sys.assigned": "{name}에게 배정했습니다",
  "sys.csat_request": "평가를 요청했습니다",
  "sys.auto_reply": "자동 응답: {body}",

  "thread.aria": "대화",
  "thread.verified": "인증된 사용자",
  "thread.you": "{name}(나)",
  "thread.reopen": "다시 열기",
  "thread.snooze": "보류",
  "thread.snoozeTitle": "고객의 답변을 기다리는 중",
  "thread.resolve": "해결",
  "thread.liveStopped": "이 대화의 실시간 업데이트가 중지되었습니다.",
  "thread.loadFailed": "이 대화를 불러오지 못했습니다.",
  "thread.loadEarlier": "이전 메시지 불러오기",
  "thread.loadEarlierFailed": "이전 메시지를 불러오지 못했습니다",
  "thread.failedRetry": "전송 실패: 다시 시도",
  "thread.typing": "{name} 님이 입력 중…",
  "thread.seen": "읽음",
  "thread.updateFailed": "업데이트하지 못했습니다",

  "composer.uploadFailed": "업로드하지 못했습니다",
  "composer.savedReplies": "저장된 답변",
  "composer.placeholder": "{name} 님에게 답장… (/를 입력해 저장된 답변 사용)",
  "composer.reply": "답장",
  "composer.attach": "📎 첨부",
  "composer.uploading": "업로드 중…",
  "composer.removeFile": "{name} 제거",
  "composer.send": "보내기",

  "faq.untitled": "(제목 없음)",
  "faq.loadFailed": "도움말 센터를 불러오지 못했습니다.",
  "faq.loadFailedToast": "도움말 센터를 불러오지 못했습니다",
  "faq.notFound": "문서를 찾을 수 없습니다.",
  "faq.backToList": "도움말 센터로 돌아가기",
  "faq.intro": "문서는 앱 내 도움말 센터에 표시되며, 고객이 채팅을 시작하기 전에 추천됩니다.",
  "faq.newArticle": "새 문서",
  "faq.categories": "카테고리",
  "faq.categoriesIntro": "문서를 주제별로 묶습니다. 제목은 언어별로 설정합니다.",
  "faq.addCategoryFailed": "카테고리를 추가하지 못했습니다",
  "faq.newCategoryPlaceholder": "새 카테고리 제목({locale})",
  "faq.addCategory": "카테고리 추가",
  "faq.noArticles": "아직 문서가 없습니다. 가장 자주 받는 질문부터 시작해 보세요.",
  "faq.uncategorized": "분류 없음",
  "faq.languages": "언어",
  "faq.views": "조회수",
  "faq.helpful": "도움됨",
  "faq.helpfulValue": "{votes}명 중 {percent}%",
  "faq.published": "게시됨",
  "faq.draft": "초안",
  "faq.missing": "없음",
  "faq.categoryTitle": "제목({locale})",
  "faq.saveCategoryFailed": "카테고리를 저장하지 못했습니다",
  "faq.categorySaved": "카테고리를 저장했습니다",
  "faq.deleteCategoryConfirm": "이 카테고리를 삭제할까요? 포함된 문서는 분류 없음이 됩니다.",
  "faq.deleteCategoryFailed": "카테고리를 삭제하지 못했습니다",
  "faq.addTitleFirst": "먼저 제목을 입력하세요",
  "faq.deleteArticleConfirm": "이 문서를 모든 언어에서 삭제할까요?",
  "faq.deleteArticleFailed": "문서를 삭제하지 못했습니다",
  "faq.category": "카테고리",
  "faq.titlePlaceholder": "어떻게 하나요?",
  "faq.untitledExisting": "{locale} 제목을 입력하거나 아래에서 {locale} 번역을 제거하세요.",
  "faq.untitledNew": "{locale} 제목을 입력하거나 본문을 비워 이 언어를 제외하세요.",
  "faq.slug": "URL 슬러그",
  "faq.slugHint": "비워 두면 제목으로 자동 생성됩니다.",
  "faq.body": "본문(Markdown)",
  "faq.bodyHint": "**굵게**, *기울임꼴*, 목록, 링크, 이미지, `코드`를 지원합니다. HTML은 텍스트로 표시됩니다.",
  "faq.publishedIn": "{locale}로 게시",
  "faq.removeTranslation": "{locale} 번역 제거",
  "faq.preview": "미리보기",
  "faq.untitledPreview": "제목 없음",

  "settings.tab.general": "일반",
  "settings.tab.hours": "운영 시간",
  "settings.tab.install": "설치",
  "settings.tab.push": "푸시 알림",
  "settings.tab.team": "팀",
  "settings.tab.canned": "저장된 답변",
  "settings.adminOnly": "워크스페이스 관리자만 이 설정을 변경할 수 있습니다.",
  "settings.loadFailed": "설정을 불러오지 못했습니다.",
  "settings.reloadFailed": "설정을 다시 불러오지 못했습니다",

  "general.branding": "브랜딩",
  "general.brandingIntro": "앱 안에서 도움말 센터와 채팅이 보이는 모습입니다.",
  "general.brandColor": "브랜드 색상",
  "general.brandColorPicker": "브랜드 색상 선택",
  "general.brandColorHex": "브랜드 색상 16진수 값",
  "general.logoUrl": "로고 URL",
  "general.logoHint": "도움말 센터 상단에 표시되는 HTTPS 이미지입니다.",
  "general.languages": "언어",
  "general.languagesIntro": "여기서 켠 언어는 기기 언어에 맞춰 화면에 표시됩니다. 문서는 기본 언어로 대체됩니다.",
  "general.defaultLanguage": "기본 언어",
  "general.greeting": "인사말({locale})",
  "general.greetingHint": "비워 두면 기본 제공 인사말을 사용합니다.",
  "general.csatTitle": "만족도 평가",
  "general.csatAsk": "대화가 해결되면 고객에게 평가를 요청합니다",

  "hours.intro": "운영 시간 외에는 고객에게 부재 중으로 표시되고 자동 응답이 전송됩니다.",
  "hours.enable": "운영 시간 사용(사용하지 않으면 항상 온라인으로 표시됩니다)",
  "hours.timezone": "시간대",
  "hours.open": "운영",
  "hours.closed": "휴무",
  "hours.opens": "{day} 시작 시간",
  "hours.closes": "{day} 종료 시간",
  "hours.replyTitle": "응답 시간 및 자동 응답",
  "hours.typical": "평균 응답 시간(분)",
  "hours.typicalHint": "온라인 상태일 때 고객에게 표시됩니다. 비워 두면 숨겨집니다.",
  "hours.away": "부재 메시지({locale})",
  "hours.awayHint": "운영 시간 외에 메시지가 오면 자동으로 전송됩니다(대화당 12시간에 최대 1회).",

  "install.keys": "키",
  "install.publishableKey": "공개 키",
  "install.publishableHint": "앱과 웹사이트에 포함해도 안전합니다.",
  "install.identitySecret": "ID 시크릿",
  "install.secretHint": "서버에 보관하세요. 사용자 ID에 서명해 채팅을 로그인한 사용자와 연결하는 데 사용합니다.",
  "install.secretHidden": "숨겨짐. 다시 생성하면 기존 사용자 해시가 즉시 무효화됩니다.",
  "install.rotateConfirm": "ID 시크릿을 다시 생성할까요? 서버가 즉시 새 시크릿으로 전환해야 합니다.",
  "install.rotateFailed": "시크릿을 다시 생성하지 못했습니다",
  "install.rotate": "시크릿 다시 생성",
  "install.origins": "허용된 웹사이트",
  "install.originsIntro": "웹 위젯을 사용할 수 있는 오리진(한 줄에 하나씩, 예: https://app.example.com). *를 입력하면 모두 허용됩니다. 모바일 앱에는 필요하지 않습니다.",
  "install.saveOrigins": "오리진 저장",
  "install.reactWeb": "React(웹)",
  "install.anyWebsite": "모든 웹사이트",
  "install.verifyUsers": "사용자 인증(서버 측)",
  "install.verifyIntro": "서버에서 사용자 해시를 계산해 사용자 ID와 함께 전달하세요.",

  "push.fcmTitle": "Android(Firebase Cloud Messaging)",
  "push.fcmIntro": "Cloud Messaging 권한이 있는 Firebase 서비스 계정 JSON을 업로드하세요.",
  "push.fcmFile": "Firebase 서비스 계정 JSON",
  "push.saveFcm": "FCM 사용자 인증 정보 저장",
  "push.apnsTitle": "iOS(Apple Push Notification service)",
  "push.apnsIntro": "Apple 개발자 계정에서 APNs 인증 키(.p8)를 만드세요.",
  "push.p8File": ".p8 키 파일",
  "push.keyId": "키 ID",
  "push.teamId": "팀 ID",
  "push.saveApns": "APNs 사용자 인증 정보 저장",
  "push.configured": "설정됨({date})",
  "push.notConfigured": "설정되지 않음",

  "team.invite": "팀원 초대",
  "team.inviteIntro": "로그인 링크가 담긴 이메일이 발송됩니다.",
  "team.role": "역할",
  "team.role.agent": "상담원",
  "team.role.admin": "관리자",
  "team.sendInvite": "초대 보내기",
  "team.inviteSent": "초대를 보냈습니다",
  "team.inviteNoEmail": "추가했습니다. 이메일은 보내지 않았습니다. 이 주소로 최근 로그인 이메일이 여러 번 발송되었으니 그중 하나를 사용하면 됩니다.",
  "team.inviteFailed": "초대하지 못했습니다",
  "team.members": "멤버",
  "team.loadFailed": "멤버를 불러오지 못했습니다.",
  "team.loadFailedToast": "멤버를 불러오지 못했습니다",
  "team.online": "온라인",
  "team.removeConfirm": "{name} 님을 제거할까요? 담당 대화는 미배정 상태가 됩니다.",
  "team.removeFailed": "멤버를 제거하지 못했습니다",

  "canned.intro": "답장 입력란에 {shortcut}를 입력하면 삽입됩니다. {name}은 고객의 이름으로, {agent}는 내 이름으로 바뀝니다.",
  "canned.shortcut": "단축어",
  "canned.shortcutHint": "영문 소문자, 숫자, 하이픈",
  "canned.message": "메시지",
  "canned.empty": "아직 저장된 답변이 없습니다. 답변을 만든 뒤 답장 입력란에 /단축어를 입력해 삽입하세요.",
  "canned.new": "새 저장된 답변",
  "canned.deleteConfirm": "저장된 답변 /{shortcut}을(를) 삭제할까요?",
  "canned.deleteFailed": "저장된 답변을 삭제하지 못했습니다",
  "canned.loadFailed": "저장된 답변을 불러오지 못했습니다.",
  "canned.loadFailedToast": "저장된 답변을 불러오지 못했습니다",
};
